<template>
	<div>
		<el-card>
			<el-form :model="form" ref="userform" :inline="true">
				<el-form-item label="用户姓名:">
					<el-input placeholder="请输入用户姓名" v-model="form.nickname" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="用户手机:">
					<el-input placeholder="请输入用户手机" v-model="form.tel" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="调整编号:">
					<el-input placeholder="请输入调整编号" v-model="form.orderid" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="调整类型:">
					<el-select v-model="form.type" placeholder="请选择调整类型">
					      <el-option label="中杰打赏" value="1"></el-option>
					      <el-option label="用户提现" value="3"></el-option>
					    </el-select>
				</el-form-item>
				<el-form-item label="调整日期:">
					<el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm()">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button  @click="resetForm()">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="log_order_num" label="调整编号" >
				</el-table-column>
				<el-table-column prop="log_user_name" label="调整用户" >
				</el-table-column>
				<el-table-column prop="log_user_phone" label="手机号" >
				</el-table-column>
				<el-table-column prop="log_money" label="调整金额" >
				</el-table-column>
				<el-table-column prop="log_time" label="提现处理时间">
				</el-table-column>
				<el-table-column prop="log_description" label="调整描述" width="180">
				</el-table-column>
				<el-table-column prop="option_admin" label="后台操作人" width="180">
				</el-table-column>
				
			</el-table>
			<Pageing :page="page" :size="size" :total="total" @current-change="handleChangePage"></Pageing>
		</el-card>
		
		<el-dialog title="详情信息" :visible.sync="dialogFormVisible">
		  <el-form :model="forminfo">
		    <el-form-item label="订单编号" :label-width="formLabelWidth">
		      <el-input v-model="forminfo.order_num" disabled autocomplete="off"></el-input>
		    </el-form-item>
			<el-form-item label="用户昵称" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.nickname" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="真实姓名" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.enter_name" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="身份证号" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.user_idcard" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="收益金额" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.price" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="收益时间" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.start_time" disabled autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="备注" :label-width="formLabelWidth">
			  <el-input v-model="forminfo.remark" disabled autocomplete="off"></el-input>
			</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="dialogFormVisible = false">取 消</el-button>
		    <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import Pageing from '../../components/page/page.vue'
	import {
		getloglist
	} from '../../api/recharge.js'
	export default {
		components: {
			Pageing
		},
		data() {
			return {
				formLabelWidth: '120px',
				dialogFormVisible:false,
				page:1,
				size:10,
				total:0,
				tableData: [],
				runmoney:0,
				checkAll: false,
				form: {
					nickname:'',
					tel:'',
					type:'',
					orderid: '',
					time: '',
				},
				moneyform:{
					incomemoney:0,
					runwater:0,
					paymoney:0,
				},
				forminfo:{},
			};
		},
		mounted() {
			this.getuserlist()
		},
		methods: {
			getuserlist(){
				getloglist({
					page:this.page,
					where:this.form
				}).then(res=>{
					console.log(res);
					this.moneyform = res.moneyform
					this.tableData = res.list.data
					this.total = res.list.total 
					
				})
				
			},
			handinfo(e){
				console.log(e);
				this.dialogFormVisible = true
				this.forminfo = e
			},
			submitForm() {
				this.getuserlist()
			},
			handleChangePage(val){
				this.page = val
				this.getuserlist()
			},
			resetForm(){
				//this.$refs.userform.resetFields()
				this.form.nickname = ''
				this.form.tel = ''
				this.form.type = ''
				this.form.orderid = ''
				this.form.time = ''
				this.getuserlist()
			}
			
		}
	};
</script>

<style lang="less" scoped>
	.runmoney{
		display: flex; 
		flex-direction: column;
		align-items: center;
		ul{
			display: flex;
			li{
				text-align: center;
				margin: 0 20px;
			}
		}
	}
	
</style>
